import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/signin/")({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/login",
      search: search as Record<string, unknown>,
      statusCode: 301,
    });
  },
});
